import { createFileRoute } from "@tanstack/react-router";
import Admin from "@/pages/Admin";

export const Route = createFileRoute("/_authenticated/admin")({
  head: () => ({
    meta: [
      { title: "Clubbeheer | De Hussel App" },
      { name: "description", content: "Beheer sessies, leden en instellingen van je tennisclub." },
      { property: "og:title", content: "Clubbeheer | De Hussel App" },
      { property: "og:description", content: "Beheer sessies, leden en instellingen van je tennisclub." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: Admin,
});
